<template>
	<v-speed-dial
		v-model="fab"
		class="speed-dial"
		direction="top"
		transition="slide-y-reverse-transition"
		z-index="99"
		fixed
		bottom
		right
	>
		<v-btn slot="activator" v-model="fab" v-blur fab>
			<v-icon
				class="speed-dial--activator"
				:class="{ active: fab }"
				color="rust-red"
				>fa-plus</v-icon
			>
		</v-btn>

		<template v-if="showAddGroup">
			<v-btn
				class="btn--add-group"
				color="ocean"
				small
				fab
				@click="$emit('action:add-group')"
			>
				<v-icon color="white" small>fas fa-users</v-icon>
			</v-btn>
			<tippy to-selector=".btn--add-group" v-bind="tippyAttrs">{{
				strings.addAccessGroup
			}}</tippy>
		</template>

		<template v-if="showCreateUser">
			<v-btn
				class="btn--create-user"
				color="orange"
				small
				fab
				@click="$emit('action:create-user')"
			>
				<v-icon color="white" small>fa-user</v-icon>
			</v-btn>
			<tippy to-selector=".btn--create-user" v-bind="tippyAttrs">{{
				strings.createUser
			}}</tippy>
		</template>
	</v-speed-dial>
</template>

<style lang="scss" scoped>
.speed-dial {
	.speed-dial--activator {
		transition: transform 150ms ease;

		&.active {
			transform: rotate(135deg);
		}
	}
}
</style>

<script>
import strings from "@/utils/strings";

export default {
	props: {
		showAddGroup: { type: Boolean, default: false },
		showCreateUser: { type: Boolean, default: false },
	},

	data: () => ({
		strings: strings.project.accessGroups,

		// Showing fab speed-dial
		fab: false,
		// Control showing of tooltips
		tooltips: false,
	}),

	computed: {
		// Repetitive attributes shared by tippy components
		tippyAttrs() {
			const retval = {
				visible: this.tooltips,
				trigger: "manual",
				placement: "left",
				hideOnClick: false,
			};

			return retval;
		},
	},

	watch: {
		fab(val) {
			this.tooltips = false;
			val && setTimeout(() => (this.tooltips = true), 450);
		},
	},
};
</script>
